import URL from 'url'

// Returns the domain from the given url.
// https://mat-beta.dev.blocket.io/annonser/hela_sverige -> mat-beta.dev.blocket.io
export const getDomain = (url) => {
  const urlObject = URL.parse(url)

  return urlObject.hostname
}

// returns the root domain from the given url.
// https://mat-beta.dev.blocket.io/annonser/hela_sverige -> blocket.io
// https://mobil.blocket.se/annonser/hela_sverige -> blocket.se
export const getRootDomain = (url) => {
  return getDomain(url)
    .split('.')
    .slice(-2)
    .join('.')
}

// returns the parent of a subdomain url
// https://mat-beta.dev.blocket.io/annonser/hela_sverige -> dev.blocket.io
// https://mobil.blocket.se/annonser/hela_sverige -> blocket.se
// https://blocket.se/annonser/hela_sverige -> blocket.se
export const getParentDomain = (url) => {
  const splitDomain = getDomain(url).split('.')

  if (splitDomain.length <= 2) {
    return splitDomain.join('.')
  }

  return splitDomain.splice(1).join('.')
}

export default {
  getDomain,
  getRootDomain,
  getParentDomain,
}
